import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
} from '@mui/material';

const NotificationForm = ({ onSubmit }) => {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, body });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        label="Title"
        variant="outlined"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        required
        fullWidth
      />
      <TextField
        label="Body"
        variant="outlined"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        required
        fullWidth
        multiline
        rows={4}
      />
      <Button type="submit" variant="contained" color="primary">
        Send Notification
      </Button>
    </Box>
  );
};

export default NotificationForm;